import React, {Component} from 'react';

class Settings extends Component {
    render() {
        return (
            <div>
                just a settings page
            </div>
        );
    }
}

export default Settings;